import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import '@angular/localize/init';
import { ClickOutsideModule } from '@epicuro-next/ataraxia/click-outside';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationModalComponent } from './components/confirmation/confirmation.component';
import { GenericModalComponent } from './components/generic-modal/generic-modal.component';
import { ModalBodyComponent } from './components/modal-body/modal-body.component';
import { ModalFooterComponent } from './components/modal-footer/modal-footer.component';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';
import { ModalComponent } from './components/modal/modal.component';
import { ConfirmationModalService } from './services/confirmation.service';
import { ModalService } from './services/modal.service';

@NgModule({
  declarations: [
    ConfirmationModalComponent,
    GenericModalComponent,
    ModalBodyComponent,
    ModalComponent,
    ModalFooterComponent,
    ModalHeaderComponent,
  ],
  imports: [CommonModule, IconsModule, NgbModalModule, ClickOutsideModule],
  exports: [
    GenericModalComponent,
    ModalBodyComponent,
    ModalComponent,
    ModalFooterComponent,
    ModalHeaderComponent,
  ],
  providers: [ConfirmationModalService, ModalService],
})
export class ModalModule {}
